import httpClient from '@/lib/httpClient'
import useAuthStore from '@/store/useAuthStore'
import { useQuery } from '@tanstack/react-query'

export default function useGetMoneyPath({ id }: { id: number | string }) {
  const teamId = useAuthStore((state) => state.currentTeamId)

  const fetchData = async () => {
    const response = await httpClient.get(`team/money-paths`)
    const rule = response.data.data.find((x) => x.id === Number(id))
    return rule
  }

  return useQuery({
    queryKey: ['money-paths', 'detail', teamId, Number(id)],
    queryFn: fetchData,
    enabled: !!id && !!teamId,
  })
}
